import { useCallback, useSyncExternalStore } from 'react';

const DEFAULT_NOTICEABLE_DIFFERENCE = 5;
export const NOTICEABLE_DIFFERENCE_MAX = 25;

const byChartId = new Map<string, number>();
const listeners = new Set<() => void>();

const subscribe = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const setSankeyNoticeableDifference = (
  chartId: string,
  value: number
): void => {
  byChartId.set(chartId, value);
  for (const listener of listeners) listener();
};

export const useSankeyNoticeableDifference = (
  chartId: string | undefined
): number => {
  const getSnapshot = useCallback(
    () =>
      (chartId ? byChartId.get(chartId) : undefined) ??
      DEFAULT_NOTICEABLE_DIFFERENCE,
    [chartId]
  );
  return useSyncExternalStore(subscribe, getSnapshot);
};
